import { RequestClientService } from "@rightship-tech/common-ui/services/basic/request-client.service";
import { autoinject } from "aurelia-framework";
import {Urls} from "../../constants/carbon-accounting/carbon-accounting-enrollment.constants";
import { CarbonAccountingCustomReportFilterModel, GetCustomerCarbonAccountingEnrollmentsResponse } from "../../models/carbon-accounting/carbon-accounting.models";

@autoinject()
export class CarbonAccountingEnrollmentService {
    
    constructor(private requestClient: RequestClientService) {
    }
    
    public GetCustomerCarbonAccountingEnrollments(customerId: number) : Promise<GetCustomerCarbonAccountingEnrollmentsResponse> {
        return this.requestClient.get<GetCustomerCarbonAccountingEnrollmentsResponse>(`${Urls.GetCustomerCarbonAccountingEnrollments}/${customerId}`, {  });
    }

    public SaveCustomerCarbonAccountingEnrollments(request) : Promise<void> {
        return this.requestClient.post<void>(`${Urls.SaveCarbonAccountingEnrollments}`, {}, request);
    }

    public GetCustomerCarbonAccountingAlerts(customerId: number) : Promise<any> {
        return this.requestClient.get(`${Urls.GetCustomerCarbonAccountingAlerts}/${customerId}`, {});
    }

    public SaveCustomerCaBusinessUnitVetAlerts(request) : Promise<void> {
        return this.requestClient.post<void>(`${Urls.SaveCustomerCaBusinessUnitVetAlerts}`, {}, request);
    }

    public GetCaEnrollmentDataForSummary(customerId: number) : Promise<any> {
        return this.requestClient.get(`${Urls.GetCaEnrollmentDataForSummary}`, { customerId: customerId });
    }

    public GetCustomerCACustomReportFilters(customerId: number, all: boolean = false) : Promise<CarbonAccountingCustomReportFilterModel[]> {
        return this.requestClient.get(`${Urls.GetCustomerCACustomReportFilters}/${customerId}`, { all: all});
    }

    public SaveCustomerCACustomReportFilters(request) : Promise<CarbonAccountingCustomReportFilterModel[]> {
        return this.requestClient.post<CarbonAccountingCustomReportFilterModel[]>(`${Urls.SaveCustomerCACustomReportFilters}`, {}, request);
    }
}